import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-DTTCzifR.js';
import { B as BaseComponent } from './p-C5lMEBcj.js';
import { r as router } from './p-Duri5p90.js';
import { d as defineCustomElement$1 } from './p-C0QfdhKo.js';

const TabMenu = /*@__PURE__*/ proxyCustomElement(class TabMenu extends H {
    base;
    constructor() {
        super();
        this.__registerHost();
        this.tabChange = createEvent(this, "tabChange");
        this.updateActiveIndex = createEvent(this, "update:activeIndex");
        this.base = new BaseComponent({ tag: 'WANGS-TAB-MENU', pt: this.pt });
    }
    get cx() {
        return this.base.cx;
    }
    get ptm() {
        return this.base.ptm;
    }
    navRef;
    inkbarRef;
    get el() { return this; }
    pt;
    type = 'tab';
    model;
    activeIndex = 0;
    useTrailingLine = true;
    currentActiveIndex = this.activeIndex;
    tabChange;
    updateActiveIndex;
    componentWillLoad() {
        this.setActiveIndex();
    }
    componentDidRender() {
        this.updateInkBar();
    }
    function(index) {
        this.currentActiveIndex = index;
    }
    onUpdateActiveIndex(index) {
        this.updateActiveIndex.emit(index);
    }
    onRoutePathChanged() {
        this.setActiveIndex();
    }
    onItemClick(event, item, index) {
        if (this.disabled(item)) {
            return event.preventDefault();
        }
        if (index !== this.currentActiveIndex) {
            this.currentActiveIndex = index;
        }
        if (item.route)
            router.navigateToRoute(item.route);
        item.command?.({ originalEvent: event, item });
        this.tabChange.emit({ originalEvent: event, index });
    }
    label(item) {
        return typeof item.label === 'function' ? item.label() : item.label;
    }
    visible(item) {
        return typeof item.visible === 'function' ? item.visible() : item.visible !== false;
    }
    disabled(item) {
        return typeof item.disabled === 'function' ? item.disabled() : item.disabled === true;
    }
    updateInkBar() {
        const tabs = this.navRef?.children;
        if (!tabs)
            return;
        let inkHighlighted = false;
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.dataset.pHighlight === 'true') {
                const tabRect = tab.getBoundingClientRect();
                const navRect = this.navRef.getBoundingClientRect();
                this.inkbarRef.style.width = `${tabRect.width}px`;
                this.inkbarRef.style.left = `${tabRect.left - navRect.left}px`;
                inkHighlighted = true;
                break;
            }
        }
        if (!inkHighlighted) {
            this.inkbarRef.style.width = '0px';
            this.inkbarRef.style.left = '0px';
        }
    }
    setActiveIndex() {
        const routePath = window.location.pathname;
        const findIndexRecursive = (path) => {
            // Find index from the element where routePath is exactly item.route
            let index = this.model?.findIndex(item => item.route && path === item.route);
            // If it cannot find exact match, recursively trim and try to match
            if (index === -1 && path.includes('/')) {
                // Trim the last segment from the path
                const newPath = path.substring(0, path.lastIndexOf('/'));
                index = findIndexRecursive(newPath);
            }
            return index;
        };
        const foundIndex = findIndexRecursive(router.stripBase(routePath));
        this.currentActiveIndex = foundIndex === -1 ? this.currentActiveIndex : foundIndex;
    }
    getPtmo(item, index) {
        const { activeIndex, model, type, useTrailingLine } = this;
        const context = {
            item,
            index,
            active: index != null && this.currentActiveIndex === index,
            disabled: item != null && this.disabled(item),
        };
        return {
            props: { activeIndex, model, type, useTrailingLine },
            state: { currentActiveIndex: this.currentActiveIndex },
            context: item ? context : undefined,
        };
    }
    render() {
        return (h(Host, { key: '5f8a4b72d7318833f395819a83675191e2a621dc', ...this.ptm('root') }, h("ul", { key: 'ea5b5613fc9ee564daf14443a0293449479da7e9', ...this.ptm('menu', this.getPtmo()), role: "menubar", ref: el => (this.navRef = el) }, this.model.map((item, i) => this.visible(item) ? (h("li", { key: this.label(item) + '_' + i, class: this.cx('menuitem', this.getPtmo(item, i)), role: "presentation", "data-ui-highlight": (this.currentActiveIndex === i).toString(), "data-ui-disabled": this.disabled(item).toString(), onClick: e => this.onItemClick(e, item, i) }, h("a", { role: "menuitem", href: item.url ?? (item.route ? router.normalizePath(item.url ?? item.route) : undefined), target: item.target, "aria-label": this.label(item), "aria-disabled": this.disabled(item) ? 'true' : 'false', tabIndex: -1, onClick: (e) => item.route && e.preventDefault(), ...this.ptm('action', this.getPtmo(item, i)) }, item.icon && h("wangs-icon", { icon: item.icon }), h("span", { class: this.cx('label') }, this.label(item))))) : null), h("li", { key: 'bc767f430fb9375154318bef4a3dfa58767caf82', ref: el => (this.inkbarRef = el), class: this.cx('inkbar', this.getPtmo()), role: "none" }))));
    }
    static get watchers() { return {
        "activeIndex": ["function"],
        "currentActiveIndex": ["onUpdateActiveIndex"]
    }; }
}, [0, "wangs-tab-menu", {
        "pt": [16],
        "type": [1],
        "model": [16],
        "activeIndex": [2, "active-index"],
        "useTrailingLine": [4, "use-trailing-line"],
        "currentActiveIndex": [32]
    }, [[8, "wangs-ui-core:navigation-event", "onRoutePathChanged"]], {
        "activeIndex": ["function"],
        "currentActiveIndex": ["onUpdateActiveIndex"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wangs-tab-menu", "wangs-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wangs-tab-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TabMenu);
            }
            break;
        case "wangs-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { TabMenu as T, defineCustomElement as d };
